<template>
    <div class="modal fade" id="modalShareInvoice" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Bagikan ke</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="one-line">
              <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-2 pl-0 pr-1">
                        <label class="ol-label">
                            Email :
                        </label>
                    </div>
                  <div class="col-lg-8 pl-0 pr-1">
                    <multiselect v-model="shareList" :options="shareOptions" tag-placeholder="Add this email address" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Pilih Email yang dituju" :multiple="true" :taggable="true" @tag="addRecipient"></multiselect>
                  </div>
                  <div class="col-lg-2 pl-0 pr-1">
                    <button type="button" class="btn btn-link" @click="resetSharedEmailList">Clear</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitChange"
              v-if="!loadingButtonSent"
            >
              Kirim
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else-if="loadingButtonSent"
            >
              <img src="~@/assets/images/2.gif" style="height: 18px" />Save
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'ModalShareInvoice',
  props: ['emailList',],
  components: {
    Multiselect,
  },
  data () {
    return {
        shareList : [],
        shareOptions:[],
        addFinanceEmail: "",
        loadingButtonSent : false,
    }
  },
  methods:{
    resetSharedEmailList () {
      this.shareList = []
    },
    addRecipient(newRecipient) {
        this.shareList = [...this.shareList, newRecipient]
        this.shareOptions = [...this.shareOptions, newRecipient]
        console.log(this.shareList)
        console.log(this.shareOptions)
    },
    submitChange () {
        // this.loadingButtonSent = !this.loadingButtonSent
        this.closeModal('UpdateFinanceEmailList')
    },
    closeModal(name){
      $("#modal"+name).modal('hide')
    },
  },
  watch : {
  },
  created(){
    this.shareOptions =  [...this.emailList]
    this.shareList = [...this.emailList ]
    // this.getData()
    // this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .check-box-text {
    color: #2E3646;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
    letter-spacing: -0.016px;
  }

  .most-overdue-title {
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-text {
    color: #2E3646;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

  .most-overdue-orange {
    color: #FF5252;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 157.143% */
    letter-spacing: -0.014px;
  }

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalShareInvoice.vue